import axios from 'axios';

const baseURL = `api/resources`;

export default {
    // Returns List of resources by filtered dependencies
    getResourcesByDependencies(filter: string) {
        const token = localStorage.getItem('token')
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return axios.get(`${baseURL}?filter=${filter}`);
    },
    getResourcesByCharacteristicCode(characteristicCode: string) {
        const token = localStorage.getItem('token')
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return axios.get(`${baseURL}/characteristic/${characteristicCode}`);
    },
};